import validate from "/usr/src/app/content/n3-spas-0305acfb-b540-4d86-a2f6-fd55f57f26e1/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-0305acfb-b540-4d86-a2f6-fd55f57f26e1/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}